import type { ExpenseState } from '@chukua/common';

export const EXPENSE_STATE_LABELS: Record<ExpenseState, string> = {
  submitted: 'Submitted',
  approved: 'Approved',
  rejected: 'Rejected',
  exception: 'Exception',
};

export const EXPENSE_STATE_TAG_COLOURS: Record<ExpenseState, string> = {
  submitted: 'processing',
  approved: 'success',
  rejected: 'error',
  exception: 'warning',
};

export const toColumnFilters = <K extends string>(labels: Record<K, string>) => (Object.keys(labels) as K[]).map((key) => ({ value: key, text: labels[key] }));
